class IframeView {
  constructor () {
    this.onclose = () => {}
    this.handleCloseIframe = this.handleCloseIframe.bind(this)
  }

  openIframe ({ iframeWidth, iframeHeight, iframeSrc }) {
    const iframeDom = this.createIframe({
      iframeWidth,
      iframeHeight,
      iframeSrc
    })
    this.createView(iframeWidth, iframeHeight, iframeDom)
    return iframeDom
  }

  createIframe ({ iframeWidth, iframeHeight, iframeSrc }) {
    const iframe = document.createElement('iframe')
    iframe.width = iframeWidth
    iframe.height = iframeHeight
    iframe.src = iframeSrc
    iframe.style.border = 'none'
    return iframe
  }

  createView (width, height, iframeDom) {
    const dialogWrapStyle = {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      'z-index': 3000,
      height: '100%',
      'background-color': 'rgba(0,0,0,.5)',
      overflow: 'auto'
    }
    const dialogStyle = {
      background: '#fff',
      width: `${width}px`,
      height: `${height}px`,
      'border-radius': '20px',
      position: 'absolute',
      top: '15vh',
      left: '50%',
      transform: 'translateX(-50%)',
      overflow: 'hidden'
    }
    const svgWrapStyle = {
      position: 'absolute',
      top: '20px',
      right: '30px',
      cursor: 'pointer'
    }
    const dialogWrap = this.createDom(
      'div',
      dialogWrapStyle,
      'bill-dialog-wrap'
    )
    const dialog = this.createDom('div', dialogStyle, 'dialog')
    const dialogHeader = this.createDom('div', '', 'dialog-header')
    const dialogBody = this.createDom('div', '', 'dialog-body')
    const svgWrap = this.createDom('div', svgWrapStyle, 'svg-wrap')
    const svg = this.createCloseSvg()
    svgWrap.appendChild(svg)
    dialogHeader.appendChild(svgWrap)
    dialog.appendChild(dialogHeader)
    dialogBody.appendChild(iframeDom)
    dialogBody.style.height = '100%'
    dialog.appendChild(dialogBody)
    dialogWrap.appendChild(dialog)
    document.body.appendChild(dialogWrap)
    dialogWrap.setAttribute('id', 'dialog-wrap')

    this.dialogWrap = dialogWrap
    svgWrap.addEventListener('click', this.handleCloseIframe)
  }

  createDom (name, style, classTag) {
    const dom = document.createElement(name)
    style && Object.assign(dom.style, style)
    classTag && dom.setAttribute('class', classTag)
    return dom
  }

  createCloseSvg () {
    const svgAttr = {
      width: 15,
      height: 15,
      viewBox: '0 0 15 15',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }
    const pathAttr1 = {
      d: 'M1.3313 13.9971L13.9955 1.00321',
      stroke: '#CACACA',
      'stroke-width': '1.36842',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round'
    }
    const pathAttr2 = {
      d: 'M1.33423 1L13.9921 14',
      stroke: '#CACACA',
      'stroke-width': '1.36842',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round'
    }
    const svg = this.setAttributeFun('svg', svgAttr)
    const path1 = this.setAttributeFun('path', pathAttr1)
    const path2 = this.setAttributeFun('path', pathAttr2)

    svg.appendChild(path1)
    svg.appendChild(path2)
    return svg
  }

  setAttributeFun (name, attr) {
    // const dom = name == 'svg' ? document.createElementNS('http://www.w3.org/2000/svg', name) : document.createElement(name)
    const dom = document.createElementNS('http://www.w3.org/2000/svg', name)

    for (const [key, value] of Object.entries(attr)) {
      dom.setAttribute(key, value)
    }
    return dom
  }

  handleCloseIframe () {
    const dialogWrap = document.querySelector('.bill-dialog-wrap')
    dialogWrap && document.body.removeChild(dialogWrap)
    this.onclose('close')
  }
}

export const searchIframe = (params) => {
  const [session, url, inputJson] = params.open()
  // const [iframe, closeDom, iframeWarp] = initDom()
  const iframeView = new IframeView()
  iframeView.openIframe({
    iframeSrc: `${url}/#/?session=${session}&iframe=true&hotjarCode=2659750`,
    iframeWidth: 700,
    iframeHeight: 720
  })

  // iframe.src = `${url}/#/?session=${session}&iframe=true`
  // iframe.onload = (e) => {
  //   closeDom.style.display = 'block'
  // }

  const handleMessage = (e) => {
    const { type, result } = e.data
    if (type === 'init') {
      const message = {
        type: 'init',
        result: inputJson
      }
      e.source.postMessage(message, '*')
    } else if (type === 'style') {
      // Object.assign(iframe.style, result)
      // console.log(`calc((100% - ${result.width}) / 2)`);
      // closeDom.style.right = `calc((100% - ${result.width}) / 2)`
    } else if (type === 'event') {
      params.event(result)
    } else if (type === 'error') {
      params.error(result)
    }
  }
  iframeView.onclose = () => {
    window.removeEventListener('message', handleMessage)
  }
  // closeDom.onclick = () => {
  //   iframeWarp.remove()
  //   params.close()
  //   window.removeEventListener('message', handleMessage)
  // }
  window.addEventListener('message', handleMessage)
}
